import axios from "axios";
import { authHeaderJson } from "../auth-header.service";



const getAllLegalEntities = () => {
    return axios.get(`/api/legalEntity`, { headers: authHeaderJson() } )
};

const getAllLE = () => {
    return axios.get(`/api/legalEntity/list`, { headers: authHeaderJson() } )
};

const getAllLegalEntityTypes = () => {
    return axios.get(`/api/legalEntity/types/list`, { headers: authHeaderJson() } )
};

const getLegalEntityById = (legalEntityId) => {
        return axios.get(`/api/legalEntity/${legalEntityId}`, { headers: authHeaderJson() } );
};

const addLegalEntity = (legalEntity) => {
    return axios.post(`/api/legalEntity/add/`, legalEntity, { headers: authHeaderJson() } );
}
const addLegalEntityList = (legalEntitys) => {
    return axios.post(`/api/legalEntity/add/list`, legalEntitys, { headers: authHeaderJson() } );
}
const saveLegalEntityById = (legalEntityId, objLegalEntity) => {
    return axios.put(`/api/legalEntity/update/${legalEntityId}`, objLegalEntity, { headers: authHeaderJson() });
};
const deleteLegalEntity = (legalEntityId) => {
    return axios.delete(`/api/legalEntity/delete/${legalEntityId}`, { headers: authHeaderJson() });
}

export {
    getAllLegalEntities,
    getAllLE,
    getAllLegalEntityTypes,
    getLegalEntityById,
    addLegalEntity,
    addLegalEntityList,
    saveLegalEntityById,
    deleteLegalEntity
}